import { render } from "./CharacterCard.vue?vue&type=template&id=248220f0"
import script from "./CharacterCard.vue?vue&type=script&lang=js"
export * from "./CharacterCard.vue?vue&type=script&lang=js"

import "./CharacterCard.vue?vue&type=style&index=0&id=248220f0&lang=css"
script.render = render

export default script